<pv-drawer
  *ngIf="showDrawer"
  [isVisible]="showDrawer"
  position="bottom"
  [showCloseIcon]="true"
  [headerTemplate]="headerTemplate"
  [contentTemplate]="contentTemplate"
  [footerTemplate]="footerTemplate"
  [showBackdrop]="true"
  [dismissOnBackdropClick]="true"
  [closeOnEscape]="true"
  [style]="pvDrawerStyleOverrides"
  (closeHandler)="handleClose()"
  (openHandler)="redeem()">
  <ng-template #headerTemplate></ng-template>
  <ng-template #contentTemplate>
    <div *ngIf="isLoading" class="p-5">
      <p-skeleton
        *ngFor="let i of 3 | pvEnumerate"
        width="100%"
        styleClass="mb-6"
        height="5rem" />
    </div>
    <div
      class="flex flex-column align-items-center mt-5 px-5"
      *ngIf="!isLoading && !redeemFailed">
      <img [src]="merchantLogo" alt="brand logo" class="border-circle logo" />
      <p class="m-0 pv-text-16px font-bold pv-mt-30px">
        {{ merchantName }}
      </p>
      <p class="m-0 pv-mt-26px pv-text-12px pv-mb-14px">
        {{ offerDetails?.attributes?.title }}
      </p>
      <div
        *ngIf="!voucherCode"
        class="py-3 text-gray-500 bg-gray-400 border-round-sm w-full text-center">
        {{ env.staticTextContents.orderHistoryPage.noVoucherText }}
      </div>
      <div
        *ngIf="voucherCode"
        class="voucher-container flex flex-column border-round-sm align-items-center w-full py-2">
        <p class="pv-text-14px m-0">
          {{ voucherCode }}
        </p>
        <div class="flex align-items-center mt-1">
          <p class="pv-text-10px mr-1">
            {{ env.staticTextContents.commonTexts.copyCode }}
          </p>
          <pv-copy
            [style]="copyIconStyle"
            toolTipPosition="right"
            [valueToBeCopied]="voucherCode"></pv-copy>
        </div>
      </div>
      <div
        class="pv-mt-12px text-primary"
        *ngIf="offerDetails?.attributes?.end_date">
        {{ env.staticTextContents.orderHistoryPage.validityText }}
        {{ ' ' }}
        {{ offerDetails?.attributes?.end_date | date: 'MMM dd, yyyy' }}
      </div>
      <p>
        <!-- prettier-ignore -->
        <a
          *ngIf="
            env.staticTextContents.orderHistoryPage.redirectionTexts
              .hyperlinkText
          "
          href="javascript:void(0)"
          (click)="handleRedemptionSteps()"
          class="text-primary">
          {{
            env.staticTextContents.orderHistoryPage.redirectionTexts
              .hyperlinkText
          }}</a>
        <span>
          {{
            env.staticTextContents.orderHistoryPage.redirectionTexts.normalText
          }}
        </span>
      </p>
      <a
        [href]="offerDetails?.attributes?.redemption_url"
        class="border-round-sm text-white py-3 redeem-link pv-text-14px no-underline bg-primary"
        target="_blank"
        rel="noopener noreferrer">
        {{ env.staticTextContents.commonTexts.redeemNow }}
      </a>
    </div>
    <div
      *ngIf="!isLoading && redeemFailed"
      class="flex flex-column align-items-center justify-content-center h-full">
      <img
        src="https://images.poshvine.com/icon/alert-triangle-red-icon.svg"
        alt="alert-icon" />
      <p class="m-0 my-3 pv-text-16 font-semibold">
        {{ env.staticTextContents.orderHistoryPage.redeemFailedMessages.title }}
      </p>
      <p class="m-0 pv-text-16 font-semibold">
        {{
          env.staticTextContents.orderHistoryPage.redeemFailedMessages.subtitle
        }}
      </p>
    </div>
  </ng-template>
  <ng-template #footerTemplate></ng-template>
</pv-drawer>
